import React, { useState } from "react";
import "./Gallery.css";

const Gallery = ({
  images = [],
  title = "Our Gallery",
  subtitle = "Explore our training programs, community work, and student achievements",
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setSelectedImage(images[index]);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const goToNext = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  // Default images if none provided
  const defaultImages = [
    {
      src: "/images/meeting02.jpg",
      alt: "Training session",
      category: "Training",
    },
    {
      src: "/images/medical-practical.jpg",
      alt: "Practical workshop",
      category: "Training",
    },
    {
      src: "/images/nurses.jpg",
      alt: "Community service",
      category: "Community",
    },
    {
      src: "/images/graduates03.jpg",
      alt: "Graduation ceremony",
      category: "Graduation",
    },
    {
      src: "/images/meeting01.jpg",
      alt: "Training facility",
      category: "Facilities",
    },
    { src: "/images/group01.jpg", alt: "Student group", category: "Students" },
    {
      src: "/images/practical01.jpg",
      alt: "Hands-on workshop",
      category: "Training",
    },
    {
      src: "/images/child-minding-01.jpg",
      alt: "Child Minding",
      category: "Child Minding",
    },
    {
      src: "/images/farming-01.jpg",
      alt: "Farming",
      category: "Farming",
    },
    {
      src: "/images/warehouse-packer-01.jpg",
      alt: "Warehouse Packer",
      category: "Warehouse Packer",
    },
  ];

  const displayImages = images.length > 0 ? images : defaultImages;

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="gallery-header">
          <h2 className="section-title">{title}</h2>
          {subtitle && <p className="gallery-subtitle">{subtitle}</p>}
        </div>

        <div className="gallery-grid">
          {displayImages.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(index)}
            >
              <div className="gallery-image-container">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <div className="overlay-content">
                    {/* <span className="view-text">View</span> */}
                  </div>
                </div>
              </div>
              {image.category && (
                <div className="image-category">{image.category}</div>
              )}
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <div
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={closeLightbox}>
                &times;
              </button>
              <button className="lightbox-nav prev" onClick={goToPrevious}>
                &#10094;
              </button>
              <div className="lightbox-image-container">
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="lightbox-image"
                />
                <div className="lightbox-caption">
                  <h3>{selectedImage.alt}</h3>
                  {selectedImage.category && (
                    <span className="lightbox-category">
                      {selectedImage.category}
                    </span>
                  )}
                  <div className="image-counter">
                    {currentIndex + 1} / {displayImages.length}
                  </div>
                </div>
              </div>
              <button className="lightbox-nav next" onClick={goToNext}>
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
